<!-- audio -->
<div class="tw-flex-center">
  <audio
    controls
    #audioController
    [style.width]="audioWidth"
    [class.hide-audio-time]="!isShowTime"
    [style.height.px]="smallSize ? '30' : 'initial'"
    (play)="onPlay($event)"
  >
    <source />
  </audio>
</div>
